// src/components/layout/LanguageToggle.tsx
// Component for switching UI language

'use client'; // Required for hooks and event handlers

import * as React from 'react';
import { Languages } from 'lucide-react'; // Icon for language selection
// TODO: Import i18n hook later (e.g., useTranslation from react-i18next)

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

/**
 * LanguageToggle component provides a button with dropdown menu
 * to switch the application's display language.
 */
export function LanguageToggle() {
  // TODO: Get current language and changeLanguage function from i18n hook
  const currentLanguage = 'en'; // Placeholder
  const changeLanguage = (lang: string) => {
    console.log('Changing language to:', lang);
    // Actual logic using i18n.changeLanguage(lang) will go here
  };

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'vi', name: 'Tiếng Việt' }, // Vietnamese
    { code: 'es', name: 'Español' }, // Spanish
  ];

  return (
    <DropdownMenu>
      {/* Dropdown Trigger: The button itself */}
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <Languages className="h-[1.2rem] w-[1.2rem]" />
          <span className="sr-only">Change language</span>
        </Button>
      </DropdownMenuTrigger>

      {/* Dropdown Content: The menu that appears on click */}
      <DropdownMenuContent align="end">
        {languages.map(lang => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            // Optionally highlight the current language
            className={currentLanguage === lang.code ? 'font-semibold' : ''}
          >
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default LanguageToggle;
